const MODULE_ID = 'meinDienst';
export default MODULE_ID;
